      import React, { useState, useEffect } from "react"
      import { useIntl } from "gatsby-plugin-intl"
      import { graphql } from "gatsby"
      import Img from "gatsby-image"
      import styled from "styled-components"
      import { GatsbyImage, getImage } from "gatsby-plugin-image"


      import ActionCard from "../components/ActionCard"
      import ButtonLink from "../components/ButtonLink"
      import Icon from "../components/Icon"
      import CalloutBanner from "../components/CalloutBanner"
      import CodeModal from "../components/CodeModal"
      import Codeblock from "../components/Codeblock"
      import LegacyPageHome from "../components/LegacyPageHome"
      import Morpher from "../components/Morpher"
      import PageMetadata from "../components/PageMetadata"
      import StatsBoxGrid from "../components/StatsBoxGrid"
      import Translation from "../components/Translation"
      import TitleCardList from "../components/TitleCardList"
      import Callout from "../components/Callout"
      import {
        CardContainer,
        Content,
        CardGrid,
        GrayContainer,
        LeftColumn,
      } from "../components/SharedStyledComponents"
      import {
        getLangContentVersion,
        translateMessageId,
        isLangRightToLeft,
      } from "../utils/translations"

      import ProductCard from "../components/ProductCard"
      import useWindowResize from "../hooks/useWindowResize"

      import EthExchanges from "../components/ChooseDestination"
      import { StaticImage } from "gatsby-plugin-image"
      import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
      //import { Carousel } from 'react-responsive-carousel';

      import Carousel from 'nuka-carousel';
      import { margin } from "styled-system"

import AddToMailchimp from "../components/marketing/AddToMailchimp"


      const StyledButton = styled.button`
  text-decoration: none;
  display: inline-block;
  white-space: nowrap;
  padding: 0.5rem 0.75rem;
  font-size: 1rem;
  border-radius: 0.25em;
  text-align: center;
  ${margin}
`

const Primary = styled(StyledButton)`
  background-color: ${(props) => props.theme.colors.primary};
  color: ${(props) => props.theme.colors.buttonColor} !important;
  border: 1px solid transparent;

  &:hover {
    background-color: ${(props) => props.theme.colors.primaryHover};
    box-shadow: ${(props) => props.theme.colors.cardBoxShadow};
  }
  &:active {
    background-color: ${(props) => props.theme.colors.primaryActive};
  }
`

const Secondary = styled(StyledButton)`
  color: ${(props) => props.theme.colors.text};
  border: 1px solid ${(props) => props.theme.colors.text};
  background-color: transparent;

  &:hover {
    color: ${(props) => props.theme.colors.primary};
    border: 1px solid ${(props) => props.theme.colors.primary};
    box-shadow: ${(props) => props.theme.colors.cardBoxShadow};
  }
  &:active {
    background-color: ${(props) =>
      props.theme.colors.secondaryButtonBackgroundActive};
  }
`

      const StyledCardGrid = styled(CardGrid)`
        margin-bottom: 2rem;
      `

      const Subtitle = styled.h2`
        font-size: 1.25rem;
        line-height: 1.4;
        font-weight: 400;
        color: ${(props) => props.theme.colors.text300};
        max-width: 55ch;
        margin-bottom: 0.5rem;
        margin-top: 1rem;
      `

      const SubtitleTwo = styled(Subtitle)`
        margin-top: 0rem;
      `

      const StackContainer = styled(Content)`
        border: 1px solid ${(props) => props.theme.colors.border};
        justify-content: flex-start;
        border-radius: 4px;
        padding: 3rem 2rem;
        margin: 2rem;
        width: 96%;
        background: ${(props) => props.theme.colors.ednBackground};
        @media (max-width: ${(props) => props.theme.breakpoints.s}) {
          width: 100%;
          margin-left: 0rem;
          margin-right: 0rem;
          border-radius: 0px;
        }
      `



      const Hero = styled(GatsbyImage)`
        width: 100%;
        min-height: 380px;
        max-height: 440px;
        background-size: cover;
        background: no-repeat 50px;
        margin-bottom: 2rem;
      `

      const StyledContent = styled(Content)`
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          padding: 1rem;
        }
      `

      const H1 = styled.h1`
        font-size: 40px;
        font-weight: 700;
        margin: 0;
        text-align: center;
        @media (max-width: ${(props) => props.theme.breakpoints.s}) {
          font-size: 32px;
        }
      `

      const Page = styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        margin: 0 auto;
      `

      const Header = styled.header`
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 1rem;
        margin-bottom: 2rem;
        padding: 0 2rem;
      `

      const ButtonRow = styled.div`
        display: flex;
        align-items: flex-start;
        @media (max-width: ${(props) => props.theme.breakpoints.m}) {
          flex-direction: column;
        }
      `

      const StyledButtonLink = styled(ButtonLink)`
        margin-left: 0.5rem;
        margin-top: 0rem;
        display: flex;
        align-items: center;
        @media (max-width: ${(props) => props.theme.breakpoints.m}) {
          margin-top: 1rem;
          margin-left: 0rem;
        }
      `

      const CodeExampleContent = styled(Content)`
        @media (max-width: ${({ theme }) => theme.breakpoints.s}) {
          padding: 1rem;
        }
      `

      const CodeboxModal = styled(CodeModal)`
        .modal-component-container {
          padding: 0;
          left: 0;
          right: 0;
          bottom: 0;
          top: 50%;
        }
        .modal-component {
          max-width: 100%;
          max-height: 50%;
          padding: 0rem;
        }
        .modal-component-content {
          margin-top: 3rem;
          width: 100%;
          overflow: auto;
        }
      `

      const IntroRow = styled.div`
        display: flex;
        align-items: center;
        margin-bottom: 3rem;
        margin-top: 1rem;
        @media (max-width: ${(props) => props.theme.breakpoints.m}) {
          flex-direction: column-reverse;
          margin: 0rem;
        }
      `

      const RowReverse = styled.div`
        display: flex;
        flex-direction: row-reverse;
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          flex-direction: column-reverse;
          align-items: center;
        }
      `

      const Row = styled.div`
        display: flex;
        flex-direction: row;
        align-items: center;
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          flex-direction: column-reverse;
          align-items: center;
        }
      `

      const ImageContainer = styled.div`
        background: "#F1FFFD";
        display: flex;
        height: 100%;
        width: 100%;
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          width: 75%;
        }
      `

      const Description = styled.p`
        color: ${(props) => props.theme.colors.text200};
        max-width: 55ch;
        text-align: center;
        align-self: center;
        font-size: 20px;
        margin-top: 1rem;
      `

      const StyledGrayContainer = styled(GrayContainer)`
        box-shadow: inset 0px 0px 0px
          ${(props) => props.theme.colors.tableItemBoxShadow};
        padding: 0rem;
        padding-bottom: 4rem;
        margin-top: 0rem;
      `
      const StyledCard = styled(ActionCard)`
        min-width: 480px;
        margin: 1rem;
        border-radius: 2px;
        border: 1px solid ${(props) => props.theme.colors.text};
        background: ${(props) => props.theme.colors.background};
        box-shadow: ${(props) => props.theme.colors.cardBoxShadow};
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          margin: 0;
          min-width: min(100%, 240px);
        }
      `
      const Tout = styled(ActionCard)`
        min-width: 400px;
        margin: 1rem;
        border-radius: 2px;
        border: 1px solid ${(props) => props.theme.colors.text};
        background: ${(props) => props.theme.colors.background};
        box-shadow: ${(props) => props.theme.colors.cardBoxShadow};
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          margin: 0;
          min-width: min(100%, 240px);
        }
      `
      const StyledCardContainer = styled(CardContainer)`
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 100%;
        margin: 0rem;
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          display: grid;
          gap: 2rem;
          grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
          grid-template-columns: 1fr;
        }
      `

      const IntroImage = styled(GatsbyImage)`
        width: 100%;
        background-size: cover;
        background: no-repeat 50px;
      `

      const FeatureImage = styled(GatsbyImage)`
        width: 100%;
      `

      /*const Subtitle = styled.div`
        margin-bottom: 2rem;
        font-size: 20px;
        line-height: 140%;
        @media (max-width: ${(props) => props.theme.breakpoints.s}) {
          font-size: 16px;
        }
      `*/

      const EthereumIntroContainer = styled.div`
        background: ${(props) => props.theme.colors.homeBoxTurquoise};
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        padding-left: 2rem;
        width: 100%;
        height: 720px;
        margin-top: -1px;
        border-top: 1px solid ${(props) => props.theme.colors.text};
        border-bottom: 1px solid ${(props) => props.theme.colors.text};
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          flex-direction: column-reverse;
          height: 100%;
          padding-top: 2rem;
          padding-left: 0rem;
          padding-bottom: 2rem;
        }
      `

      const FinanceContainer = styled.div`
        background: ${(props) => props.theme.colors.homeBoxOrange};
        display: flex;
        align-items: center;
        flex-direction: row;
        width: 100%;
        height: 720px;
        margin-top: -1px;
        border-top: 1px solid ${(props) => props.theme.colors.text};
        border-bottom: 1px solid ${(props) => props.theme.colors.text};
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          flex-direction: column-reverse;
          height: 100%;
          height: 100%;
          padding-top: 2rem;
          padding-right: 0rem;
          padding-bottom: 2rem;
        }
      `

      const NftContainer = styled.div`
        background: ${(props) => props.theme.colors.homeBoxMint};
        display: flex;
        align-items: center;
        flex-direction: row;
        width: 100%;
        height: 720px;
        margin-top: -1px;
        border-top: 1px solid ${(props) => props.theme.colors.text};
        border-bottom: 1px solid ${(props) => props.theme.colors.text};
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          flex-direction: column-reverse;
          height: 100%;
          height: 100%;
          padding-top: 2rem;
          padding-right: 0rem;
          padding-bottom: 2rem;
        }
      `

      const InternetContainer = styled.div`
        background: ${(props) => props.theme.colors.homeBoxPink};
        display: flex;
        align-items: center;
        flex-direction: row-reverse;
        padding-left: 2rem;
        height: 720px;
        width: 100%;
        margin-top: -1px;
        margin-bottom: 0rem;
        border-top: 1px solid ${(props) => props.theme.colors.text};
        border-bottom: 1px solid ${(props) => props.theme.colors.text};
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          flex-direction: column-reverse;
          height: 100%;
          padding-top: 2rem;
          padding-left: 0rem;
          padding-bottom: 2rem;
        }
      `

      const DeveloperContainer = styled.div`
        background: ${(props) => props.theme.colors.homeBoxPurple};
        display: flex;
        align-items: center;
        flex-direction: row;
        height: 720px;
        width: 100%;
        margin-top: -1px;
        border-top: 1px solid ${(props) => props.theme.colors.text};
        border-bottom: 1px solid ${(props) => props.theme.colors.text};
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          flex-direction: column-reverse;
          height: 100%;
        }
      `

      const FeatureContent = styled(LeftColumn)`
        padding: 6rem;
        height: 100%;
        width: 100%;
        margin: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          padding: 2rem;
        }
      `

      const LeftColumnContent = styled.div`
        display: flex;
        flex-direction: column;
        justify-content: center;
      `

      const IntroLeftColumn = styled(LeftColumn)`
        padding: 6rem;
        height: 100%;
        width: 100%;
        margin: 0;
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          padding: 2rem;
        }
        @media (max-width: ${(props) => props.theme.breakpoints.s}) {
          padding: 0rem;
        }
      `

      const StyledIcon = styled(Icon)`
        fill: ${(props) => props.theme.colors.text};
        margin-right: 0.5rem;
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
        }
        &:hover {
          fill: ${(props) => props.theme.colors.primary};
        }
        &:active {
          fill: ${(props) => props.theme.colors.primary};
        }
        &:focus {
          fill: ${(props) => props.theme.colors.primary};
        }
      `

      const H2 = styled.h2`
        margin: 0 0 1.5rem;
      `

      const StyledH2 = styled.h2`
        margin-bottom: 0.5rem;
        font-family: serif;
        @media (max-width: ${(props) => props.theme.breakpoints.s}) {
          font-size: 24px;
        }
      `

      const StyledCardList = styled(TitleCardList)`
        margin-left: 4rem;
        max-width: 624px;
        border: 1px solid ${(props) => props.theme.colors.text};
        box-shadow: ${(props) => props.theme.colors.cardBoxShadow};
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          margin-left: 0rem;
          max-width: 100%;
        }
      `

      const StyledCalloutBanner = styled(CalloutBanner)`
        margin: 8rem 0 4rem;
        padding: 2rem 4rem;
        @media (max-width: ${(props) => props.theme.breakpoints.l}) {
          margin-bottom: 4rem;
          padding: 2rem;
        }
      `


        const settings = {
          dots: true,
          infinite: true,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1
        };

      const HomePage = ({ data, pageContext, ...props }) => {
        const intl = useIntl()
        const isRightToLeft = isLangRightToLeft(intl.locale)
        const [isModalOpen, setModalOpen] = useState(false)
        const [activeCode, setActiveCode] = useState(0)
        const [isRendered, setIsRendered] = useState(false);
        const isSmallScreen = useWindowResize()

        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
          };

        useEffect(() => {
          setIsRendered(true);
        }, []);
        const toggleCodeExample = (id) => {
          setActiveCode(id)
          setModalOpen(true)
        }

        const hero = getImage(data.hero)
        const impact = getImage(data.impact)

        return (
          <Page dir={isRightToLeft ? "rtl" : "ltr"}>
            <PageMetadata
              title={translateMessageId("page-index-meta-title", intl)}
              description={translateMessageId("page-index-meta-description", intl)}
            />
            <Hero
              image={hero}
              alt={translateMessageId("page-index-hero-image-alt", intl)}
              loading="eager"
            />
            {/*isRendered ?

              <div style={{direction: 'initial'}}><Carousel autoPlay infiniteLoop showThumbs={false}>
                      <div>
                          <GatsbyImage image={hero} alt="A kitten"  />
                          <p className="legend">Legend 1</p>
                      </div>
                      <div>
                          <GatsbyImage image={impact} alt="A kitten"  />
                          <p className="legend">Legend 2</p>
                      </div>
                      <div>
                          <GatsbyImage image={hero} alt="A kitten"  />
                          <p className="legend">Legend 3</p>
                      </div>
                  </Carousel> </div>: <div>loading...</div>*/}


                        <FinanceContainer>
                          <Row>
                            <FeatureContent>
                              <LeftColumnContent>
                                <StyledH2>
                                  <Translation id="page-index-about" />
                                </StyledH2>
                                <Subtitle>
                                  <Translation id="page-index-what-is-melali-description" />
                                </Subtitle>
                                <div>
                                  <ButtonLink to="/defi/">
                                    <Translation id="page-index-about-button" />
                                  </ButtonLink>
                                </div>
                              </LeftColumnContent>
                            </FeatureContent>
                            <ImageContainer>
                              <FeatureImage
                                image={impact}
                                alt={translateMessageId("page-index-about-image-alt", intl)}
                              />
                            </ImageContainer>
                          </Row>
                        </FinanceContainer>



                  <StackContainer>
                    <Subtitle>
                      <Translation id="featured-from-the-blog" />
                    </Subtitle>
                    <p>
                      <Translation id="featured-from-the-blog" />
                    </p>
                    <StyledCardGrid>
                      {data.blogPosts.edges.slice(0,4).map(({node: blogPost}, idx) => (
                        <ProductCard
                          key={idx}
                          url={blogPost.url}
                          background={blogPost.background}
                          alt={translateMessageId(blogPost.title, intl)}
                          image={getImage(blogPost.featuredimage)}
                          name={translateMessageId("read-more", intl)}
                        >
                        </ProductCard>
                      ))}
                    </StyledCardGrid>
                  </StackContainer>




      {/*<Carousell slidesToShow={3} autoplay >
      {data.blogPosts.edges.map(({node: blogPost}, idx) => (
        <ProductCard
          key={idx}
          url={blogPost.url}
          background={blogPost.background}
          alt={translateMessageId(blogPost.title, intl)}
          image={getImage(blogPost.featuredimage)}
          name={blogPost.title}
          subjects={blogPost.tags}
        >
          <Translation id={blogPost.description} />
        </ProductCard>
      ))}
        </Carousell>*/}

<StackContainer>

<Subtitle>
  <Translation id="bucket-list" />
</Subtitle>


        <Carousel
  autoplay
  wrapAround
  autoplayInterval={1500}
  slidesToShow={isSmallScreen ? 1 : 3}
  renderCenterLeftControls={({ previousSlide }) => (
    <Primary onClick={previousSlide}>
      {translateMessageId("previous", intl)}
    </Primary>
  )}
  renderCenterRightControls={({ nextSlide }) => (
    <Primary onClick={nextSlide}>
      {translateMessageId("next", intl)}
    </Primary>
  )}
>
  {data.blogPosts.edges.filter(({node: post})=>post.category==='itinerary').slice(0, 10).map(({ node: blogPost }, idx) => (
      <ProductCard
        dir={isRightToLeft ? "rtl" : "ltr"}
        key={idx}
        url={blogPost.slug}
        background={blogPost.background}
        alt={blogPost.title}
        image={
          blogPost.category === "videos"
            ? `https://i1.ytimg.com/vi/${blogPost.description}/hqdefault.jpg`
            : getImage(blogPost.featuredimage)
        }
        name={translateMessageId("read-more", intl)}
        description={blogPost.title}
      ></ProductCard>
    ))}
</Carousel>
</StackContainer>



      <AddToMailchimp
      image={impact}
      alt={translateMessageId("page-index-about-image-alt", intl)}
      />

          </Page>
        )
      }

      export default HomePage
      // ($language: String!)
      export const query = graphql`
        query homeQuery($language: String!){
          impact: file(relativePath: { eq: "wallets/find-wallet.png" }) {
            childImageSharp {
              gatsbyImageData(
                width: 1440
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
          hero: file(relativePath: { eq: "home/hero.jpeg" }) {
            childImageSharp {
              gatsbyImageData(
                width: 1440
                placeholder: BLURRED
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }


          blogPosts: allMdxBlogPost(
            sort: { order: DESC, fields: [date] }
            filter: { templateKey: { eq: "blog-post" }, locale: { eq: $language } }
          ) {
            edges {
              node {
                excerpt
                id
                slug
                title
                locale
                category
                tags
                description
                templateKey
                date(formatString: "MMMM DD, YYYY", locale: $language)
                ... on MdxBlogPost {
                  featuredimage {
                    childImageSharp {
                      gatsbyImageData(
                        width: 1440
                        placeholder: BLURRED
                        formats: [AUTO, WEBP, AVIF]
                      )
                    }
                  }
                }
              }
            }
          }


        }
      `
